/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

// TODO Seems that this should be adjusted for 3. step as well? To enter code?
const SubscriptionSms = (props) => {
  const { recurringMessage, smsSupport, pinURL } = props;

  return (
    <div className="paymentOption-sms">
      <div>
        <div className="form-group mbl">
          <form action={pinURL} data-target=".paymentOption-sms" data-disableloader="1" method="post">
            <div>{get(translations, 'txt: Lūdzu, ievadi savu tālruņa numuru:', 'Lūdzu, ievadi savu tālruņa numuru:')}</div>
            <div className="por">
              <div className="paymentOption-countryCode">{`+${get(globals, 'smsPrefix', '371')}`}</div>
              <div className="fr">
                <input
                  id="Phone"
                  name="phone"
                  type="text"
                  className="form-control paymentOption-phoneInput mbl"
                />
              </div>
            </div>
            <input
              id="Code"
              name="code"
              value="opg"
              type="hidden"
            />
            <button type="submit" className="btn btn--block btn--b tac">
              {get(translations, 'txt: Turpināt', 'Turpināt')}
            </button>
          </form>
        </div>
        <div className="paymentOption-smallText">
          <p className="twb">{`* ${get(translations, recurringMessage, recurringMessage)}`}</p>
          <p>{get(translations, smsSupport, smsSupport)}</p>
        </div>
      </div>
    </div>
  );
};

SubscriptionSms.propTypes = {
  pinURL: PropTypes.string.isRequired,
  recurringMessage: PropTypes.string.isRequired,
  smsSupport: PropTypes.string.isRequired,
};

export default SubscriptionSms;
